<script setup>
// Edit / duplicate / delete affordances added to each row of Chatwoot's official
// Settings -> Templates list. Only shown for templates that live on a WhatsApp Cloud API inbox,
// which is the only provider whose templates we can write back to.
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useWasapiModules } from 'dashboard/wasapi/modules/useWasapiModules';
import {
  deleteTemplate,
  duplicateTemplate,
  inboxIdFor,
  isEditable,
  isManageable,
  openTemplate,
} from '../manager';

const props = defineProps({
  template: { type: Object, required: true },
});

const { isEnabled } = useWasapiModules();

const canManage = computed(
  () => isEnabled('templates') && isManageable(props.template)
);
const canEdit = computed(() => isEditable(props.template));
</script>

<template>
  <div v-if="canManage" class="flex items-center gap-1 shrink-0">
    <Button
      v-if="canEdit"
      v-tooltip.top="$t('WASAPI_TEMPLATES.EDIT')"
      icon="i-lucide-pencil"
      color="slate"
      size="sm"
      :aria-label="$t('WASAPI_TEMPLATES.EDIT')"
      @click.stop="openTemplate(template, inboxIdFor(template))"
    />
    <Button
      v-tooltip.top="$t('WASAPI_TEMPLATES.DUPLICATE')"
      icon="i-lucide-copy"
      color="slate"
      size="sm"
      :aria-label="$t('WASAPI_TEMPLATES.DUPLICATE')"
      @click.stop="duplicateTemplate(template)"
    />
    <Button
      v-tooltip.top="$t('WASAPI_TEMPLATES.DELETE.CONFIRM')"
      icon="i-lucide-trash-2"
      color="ruby"
      size="sm"
      :aria-label="$t('WASAPI_TEMPLATES.DELETE.CONFIRM')"
      @click.stop="deleteTemplate(template)"
    />
  </div>
</template>
